/* Bumpers smart recommendations (draft 1.11.2026). Theme-only, by product_type, round-robin one per category, best-selling first.
   window.BumpersRecs.pick({ seedTypes:[...], excludeIds:[...], max:n }) -> Promise<products[]> */
(function () {
  if (window.BumpersRecs) return;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MAP = {
    'כפכפי מסאז': ['כפכפי בית', 'מדרסים', 'מגפיים', 'מוצרים משלימים', 'שטיחי עיסוי'],
    'כפכפי בית': ['כפכפי מסאז', 'מדרסים', 'מוצרים משלימים'],
    'מגפיים': ['כפכפי מסאז', 'מדרסים', 'מוצרים משלימים'],
    'מדרסים': ['כפכפי מסאז', 'כפכפי בית', 'מוצרים משלימים'],
    'מוצרים משלימים': ['כפכפי מסאז', 'כפכפי בית', 'מדרסים'],
    'שטיחי עיסוי': ['כפכפי מסאז', 'כפכפי בית', 'מדרסים']
  };
  var feed = null;
  function load() {
    if (!feed) feed = fetch(ROOT + 'collections/all?sort_by=best-selling&view=bumpers-recs', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (j) { return j.products || []; })
      .catch(function () { feed = null; return []; });
    return feed;
  }
  function pick(o) {
    o = o || {};
    var seeds = (o.seedTypes || []).filter(Boolean), ex = (o.excludeIds || []).map(String), max = o.max || 4;
    var al = o.alias || {}; /* PDP /en: translated product types -> Hebrew keys (drawer passes none) */
    return load().then(function (all) {
      var cats = [];
      seeds.forEach(function (s) { (MAP[s] || MAP['כפכפי מסאז']).forEach(function (c) { if (cats.indexOf(c) < 0) cats.push(c); }); });
      if (!seeds.length) cats = MAP['כפכפי מסאז'].slice();
      cats = cats.filter(function (c) { return seeds.indexOf(c) < 0; });
      /* optional (PDP only, 2.11): skipTypes drops categories; prefer = handles moved to the front of their pool */
      var skip = o.skipTypes || [], pref = o.prefer || [];
      if (skip.length) cats = cats.filter(function (c) { return skip.indexOf(c) < 0; });
      var pools = cats.map(function (c) {
        var pool = all.filter(function (p) { return (al[p.type] || p.type) === c && ex.indexOf(String(p.id)) < 0 && p.price > 0 && p.variants && p.variants.length; });
        if (pref.length) pool = pool.filter(function (p) { return pref.indexOf(p.handle) >= 0; }).sort(function (a, b) { return pref.indexOf(a.handle) - pref.indexOf(b.handle); })
          .concat(pool.filter(function (p) { return pref.indexOf(p.handle) < 0; }));
        return pool;
      });
      var out = [], i = 0;
      while (out.length < max && pools.some(function (p) { return p.length; })) {
        var pool = pools[i % pools.length]; if (pool.length) out.push(pool.shift()); i++;
      }
      return out;
    });
  }
  function money(c) { var n = c / 100; return '₪' + (n % 1 ? n.toFixed(2) : n); }
  function priceHtml(price, cmp) {
    if (cmp && cmp > price) return '<s><span class="visually-hidden">' + (/^he/i.test(document.documentElement.lang || 'he') ? 'מחיר רגיל ' : 'Regular price ') + '</span>' + money(cmp) + '</s> <strong>' + money(price) + '</strong> <span class="brx-save">' + (/^he/i.test(document.documentElement.lang || 'he') ? 'חסכת ' : 'You save ') + money(cmp - price) + '</span>';
    return '<strong>' + money(price) + '</strong>';
  }
  window.BumpersRecs = { pick: pick, money: money, priceHtml: priceHtml, MAP: MAP };

  /* PDP widget: <div data-brx data-type=".." data-id=".."> */
  function L(he, en) { return /^he/i.test(document.documentElement.lang || 'he') ? he : en; }
  var EN_TYPES = { 'Massage slippers': 'כפכפי מסאז', 'Slippers': 'כפכפי בית', 'Insoles': 'מדרסים', 'Complementary Products': 'מוצרים משלימים', 'Boots': 'מגפיים', 'Massage mats': 'שטיחי עיסוי' };
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function card(p) {
    var v0 = p.variants[0];
    var sizes = p.single ? '' : '<div class="brx-sizes" role="radiogroup" aria-label="' + L('בחירת מידה ל', 'Choose size for ') + esc(p.title) + '">' +
      p.variants.map(function (v) { return '<button type="button" role="radio" aria-checked="false" class="brx-size" data-id="' + v.id + '" data-p="' + v.price + '" data-c="' + v.compare_at_price + '">' + esc(v.title) + '</button>'; }).join('') + '</div>';
    return '<article class="brx-card" role="listitem"><a class="brx-img" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true"><img src="' + esc(p.img || '') + '" alt="" width="88" height="88" loading="lazy"></a>' +
      '<div class="brx-info"><a class="brx-title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><p class="brx-price">' + priceHtml(v0.price, v0.compare_at_price || p.compare_at_price) + '</p>' + sizes +
      '<button type="button" class="brx-add"' + (p.single ? ' data-id="' + v0.id + '"' : ' disabled') + '>' + (p.single ? L('הוספה לסל', 'Add to cart') : L('בחרו מידה', 'Choose size')) + '</button><p class="brx-err" role="alert"></p></div></article>';
  }
  function mount(el) {
    if (el.dataset.brxDone) return; el.dataset.brxDone = '1';
    var cartIds = [];
    fetch(ROOT + 'cart.js').then(function (r) { return r.json(); }).catch(function () { return { items: [] }; }).then(function (c) {
      var AL = /^en/i.test(document.documentElement.lang || '') ? EN_TYPES : {}, ty = function (t) { return AL[t] || t; };
      var types = [ty(el.dataset.type)];
      (c.items || []).forEach(function (it) { cartIds.push(it.product_id); if (types.indexOf(ty(it.product_type)) < 0) types.push(ty(it.product_type)); });
      var max = Number(el.dataset.max || 4), prefer = (el.dataset.prefer || '').split(',').filter(Boolean), pinH = el.dataset.pin || '';
      return load().then(function (all) {
        /* PDP pin (Gal 2.11): pinned product (insoles) always first, unless the visitor is viewing that category */
        var pin = null;
        if (pinH) all.forEach(function (p) { if (!pin && p.handle === pinH && p.variants && p.variants.length) pin = p; });
        if (pin && (ty(pin.type) === types[0] || String(pin.id) === String(el.dataset.id))) pin = null;
        return pick({ seedTypes: types, excludeIds: cartIds.concat([el.dataset.id]).concat(pin ? [pin.id] : []), max: max, /* pin is added on top of max: nothing removed */
          skipTypes: pin ? [ty(pin.type)] : [], prefer: prefer, alias: AL }).then(function (l) { return pin ? [pin].concat(l) : l; });
      });
    }).then(function (list) {
      if (!list.length) { el.hidden = true; return; }
      el.querySelector('[data-brx-track]').innerHTML = list.map(card).join(''); el.hidden = false;
    });
    el.addEventListener('click', function (e) {
      var s = e.target.closest('.brx-size');
      if (s) {
        var c = s.closest('.brx-card');
        c.querySelectorAll('.brx-size').forEach(function (b) { var on = b === s; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on); });
        var a = c.querySelector('.brx-add'); a.dataset.id = s.dataset.id; a.disabled = false; a.textContent = L('הוספה לסל · מידה ', 'Add to cart · size ') + s.textContent;
        c.querySelector('.brx-price').innerHTML = priceHtml(Number(s.dataset.p), Number(s.dataset.c)); return;
      }
      var add = e.target.closest('.brx-add');
      if (!add || !add.dataset.id) return;
      add.disabled = true;
      var drawer = document.querySelector('cart-drawer');
      fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(add.dataset.id), quantity: 1 }], sections: 'bumpers-cart,cart-icon-bubble', sections_url: location.pathname }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (j) { if (drawer && drawer.renderContents) drawer.renderContents(j); add.closest('.brx-card').remove(); if (!el.querySelector('.brx-card')) el.hidden = true; })
        .catch(function (err) { add.disabled = false; var m = add.parentNode.querySelector('.brx-err'); if (m) m.textContent = (err && err.description) || L('לא הצלחנו להוסיף, נסו שוב', 'Could not add, please try again'); });
    });
  }
  function init() { document.querySelectorAll('[data-brx]').forEach(mount); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
